import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const groupService = {
    getAllGroups,
    createGroup,
    getGroup,
    updateGroup,
    updateGroupStatus,
};

const MODULE = {
    GROUP: 'groups',
}

const API_URL = API.BASE_URL + '/v1';

export async function getAllGroups(filter) {
    const requestOptions = {
        params: {
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    if (filter?.group) requestOptions.params.group = filter?.group;

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            requestOptions.params[searchParam] = word;
        }
    });
    return await apiHelper(API_URL).get(`/${MODULE.GROUP}`, requestOptions);
}

export async function createGroup(data) {
    const formData = new FormData();
    formData.append(`name`, data.name);
    formData.append(`api_code`, data.apiCode);
    formData.append(`color_code`, data.colorCode);
    formData.append(`investor_url`, data.investorUrl);
    formData.append(`website_url`, data.websiteUrl);
    if(data.services && data.services.length > 0) {
        data.services.forEach((tag, index) => {
            formData.append(`services[${index}]`, tag);
        });
    }
    if (data.image instanceof File) {
        formData.append('image', data.image);
    }
    return apiHelper(API_URL).post(`/${MODULE.GROUP}`, formData);
}

export async function getGroup(id) {
    return apiHelper(API_URL).get(`/${MODULE.GROUP}/${id}`);
}

export async function updateGroup(data) {
    const formData = new FormData();
    formData.append(`name`, data.name);
    formData.append(`api_code`, data.apiCode);
    formData.append(`color_code`, data.colorCode);
    formData.append(`investor_url`, data.investorUrl);
    formData.append(`website_url`, data.websiteUrl);
    if(data.services && data.services.length > 0) {
        data.services.forEach((tag, index) => {
            formData.append(`services[${index}]`, tag);
        });
    }
    if (data.image instanceof File) {
        formData.append('image', data.image);
    }
    formData.append('_method', "put");
    return apiHelper(API_URL).post(`/${MODULE.GROUP}/${data.id}`, formData)
}

export async function updateGroupStatus(data) {
    const requestOptions = {
        is_active: data.isActive,
    }
    return apiHelper(API_URL).patch(`/${MODULE.GROUP}/${data.id}`, requestOptions);
}